module.exports = __webpack_public_path__ + "static/flags/NF-1c15af062cd331d5dc1095e44392bd69.gif";